module.exports = __webpack_public_path__ + "img/20210217.6fecf615.gif";